/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { GridLayout } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { GLOBAL_APP_COUNT } from '@zapier/constants';
import { Accordion, Spacer, Text } from '@zapier/design-system';

import { generateFaqs } from './generateFaqs';

const rootStyles = css`
  margin: 0 auto;
  max-width: 800px;
`;

const faqs = generateFaqs({
  numberOfApps: GLOBAL_APP_COUNT,
});

/**
 * An accordion component that displays frequently asked questions about pricing and packaging.
 */
export const Faq = () => (
  <div css={rootStyles}>
    <Text tag="h1" textAlign="center" type="header700">
      Frequently Asked Questions
    </Text>

    <Spacer height={50} />

    <GridLayout gap={5}>
      {faqs.map((faq, index) => (
        <Accordion key={index} title={faq.question}>
          <Text type="altText900">{faq.answer}</Text>
        </Accordion>
      ))}
    </GridLayout>
  </div>
);
